export default "__VITE_ASSET__dJ$ULFcuzX43djbIEsCZPw__ 480w, __VITE_ASSET__BjjUHagISQHtPWYmu3KuwQ__ 768w, __VITE_ASSET__K1daVVNYU_lXF$FdA5v55g__ 1200w";